import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import {
  Icon,
  Heading,
  TextWithTooltip,
  Text,
  IconWithTooltip
} from 'components/common/Elements/Elements';

import { links } from 'data/constants';

import classes from './Networks.module.scss';

const { innerIcons } = links;

const Networks = ({ data }) => {
  const { t } = useTranslation(['activity']);

  return (
    <div className={classes.cell}>
      <div className={classes.network_icon_wrap}>
        {!data.networkIcon ||
        data.networkIcon ===
          '6a4f380370d56b43193171aababaf3bfa2f8002d7378b03db9207409f7734753_network_icon.png' ? (
          <Icon size="14px" icon="network" color="#3a5ba2" />
        ) : (
          <img
            className={classes.img}
            src={`${innerIcons}${data.networkIcon}`}
            width="32"
            height="32"
            alt=""
          />
        )}
      </div>
      <div>
        <div className={classes.nameAndAtributesWrap}>
          <div className={classes.overflow}>
            <Heading className={classes.overflow}>
              <TextWithTooltip
                text={data.networkName}
                saveNotification="activity:platform.TEXT_COPY"
              />
            </Heading>
          </div>
          <div className={classes.atributesWrap}>
            {data.attributes && data.attributes.customDNS && (
              <div className={classes.iconAtributes}>
                <IconWithTooltip
                  icon="customDNS"
                  color="#3a5ba2"
                  text={t('activity:platform.CUSTOM_DNS')}
                />
              </div>
            )}
            {((data.attributes && data.attributes.dnsFiltering) ||
              (data.attributes && data.attributes.urlFiltering)) && (
              <div className={classes.iconAtributes}>
                <IconWithTooltip
                  icon="filter"
                  color="#3a5ba2"
                  text={t('activity:platform.DNS_FILTERING')}
                  size="15px"
                />
              </div>
            )}
            {data.attributes && data.attributes.splitTunneling && (
              <div className={classes.iconAtributes}>
                <IconWithTooltip
                  icon="split"
                  color="#3a5ba2"
                  text={t('activity:platform.SPLIT_TUNNELING')}
                  size="12px"
                />
              </div>
            )}
          </div>
        </div>
        <Text>
          <TextWithTooltip
            text={data.networkDns}
            saveNotification="activity:platform.TEXT_COPY"
          />
        </Text>
      </div>
    </div>
  );
};

Networks.propTypes = {
  data: PropTypes.object.isRequired
};

export default Networks;
